import { forwardRef, ReactElement } from "react";
import { Icon, IconBase, IconWeight } from "@phosphor-icons/react";

const weights = new Map<IconWeight, ReactElement>([
    ["thin",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>
    ],
    ["light",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>
    ],
    ["regular",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>
    ],
    ["bold",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>
    ],
    ["fill",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>
    ],
    [
        "duotone",
        <>
            <path d="M176,128c0,4.4-3.6,8-8,8h-32v32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-32H88c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h32V88
	c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v32h32C172.4,120,176,123.6,176,128z"/>
            <path d="M127.4,24.4C70.1,24.4,24,70.5,24,127.8c0,16.7,4,33.4,11.9,48.5l-11.1,34.2c-2.4,8,1.6,17.5,10.3,19.9
	c3.2,0.8,7.2,0.8,10.3,0l34.2-11.1c50.1,27.1,113,8,140-43s8-113-43-140C160.8,28.4,144.1,24.4,127.4,24.4z M127.4,215.3
	c-15.1,0-30.2-4-43.8-11.9c-1.6-0.8-4-1.6-6.4-0.8l-37.4,12.7l12.7-37.4c0.8-2.4,0.8-4.8-0.8-6.4C28,129.4,42.3,76.1,83.7,52.2
	s95.5-9.5,119.3,31.8s9.5,95.5-31.8,119.3C157.7,211.4,142.5,215.3,127.4,215.3z"/>
        </>,
    ],
]);

const NewChat: Icon = forwardRef((props, ref) => (
    <IconBase ref={ref} {...props} weights={weights} />
));

NewChat.displayName = "NewChat";

export default NewChat;
